import authAxios from "../utils/authAxios";

/**
 * Админка озвучки: покрытие пресетов, пул заданий, расход провайдеров. Все пути под
 * /admin, и бэкенд пускает туда только роль ADMIN — меню лишь прячет пункт, гейт не здесь.
 */
const json = { 'Content-Type': 'application/json' };

const adminAudioClient = {
    getCoverage: () => authAxios('/admin/audio/coverage/presets', { method: 'GET' }),
    getPresetCoverage: (presetId) => authAxios(`/admin/audio/coverage/presets/${presetId}`, { method: 'GET' }),
    getPresetProblems: (presetId) => authAxios(`/admin/audio/coverage/presets/${presetId}/problems`, { method: 'GET' }),
    recomputeCoverage: (presetId) =>
        authAxios(`/admin/audio/coverage/presets/${presetId}/recompute`, { method: 'POST' }),
    auditPreset: (presetId, scope) =>
        authAxios(`/admin/audio/coverage/presets/${presetId}/audit?scope=${scope.join(',')}`, { method: 'POST' }),

    estimateJob: (request) => authAxios('/admin/audio/jobs/estimate', { method: 'POST', data: request, headers: json }),
    createJob: (request) => authAxios('/admin/audio/jobs', { method: 'POST', data: request, headers: json }),
    listJobs: (status) => authAxios(`/admin/audio/jobs${status ? `?status=${status}` : ''}`, { method: 'GET' }),
    getJob: (jobId) => authAxios(`/admin/audio/jobs/${jobId}`, { method: 'GET' }),
    pauseJob: (jobId) => authAxios(`/admin/audio/jobs/${jobId}/pause`, { method: 'POST' }),
    resumeJob: (jobId) => authAxios(`/admin/audio/jobs/${jobId}/resume`, { method: 'POST' }),
    cancelJob: (jobId) => authAxios(`/admin/audio/jobs/${jobId}/cancel`, { method: 'POST' }),
    runJobNow: (jobId) => authAxios(`/admin/audio/jobs/${jobId}/run-now`, { method: 'POST' }),

    getUsage: () => authAxios('/admin/audio/usage', { method: 'GET' }),
    getLimits: () => authAxios('/admin/audio/usage/limits', { method: 'GET' }),
};

export default adminAudioClient;
